import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import Toggle from '@components-clean/core/toggle';

interface IProps {
    isDisabled: boolean;
}
interface IForm {
    toggle: boolean;
}

const TogglesPage = ({ isDisabled }: IProps) => {
    const { control } = useForm<IForm>({
        mode: 'all',
    });

    return (
        <div className="k-pb-8" style={{ minWidth: 150, maxWidth: 350 }}>
            <form noValidate className="k-d-flex-col k-gap-8">
                <Controller
                    control={control}
                    name="toggle"
                    render={({ field: { onChange, value, name } }) => {
                        return (
                            <Toggle
                                name={name}
                                data-testid="text-toggle"
                                value={value}
                                onChange={onChange}
                                disabled={isDisabled}
                            >
                                Toggle / Switch
                            </Toggle>
                        );
                    }}
                />
            </form>
        </div>
    );
};

export default TogglesPage;
